import React, { Component } from 'react';
import PropTypes from 'prop-types';
import keycode from 'keycode';
import classNames from 'classnames';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import AccessibilityNewIcon from '@material-ui/icons/AccessibilityNew';
import { Scanner, Scannable } from 'react-scannable';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Alert from '@material-ui/lab/Alert';

import Grid from '../Grid';
import Symbol from './Symbol';
import OutputContainer from './Output';
import Navbar from './Navbar';
import EditToolbar from './EditToolbar';
import Tile from './Tile';
import EmptyBoard from './EmptyBoard';
import { DISPLAY_SIZE_GRID_COLS } from '../Settings/Display/Display.constants';
import NavigationButtons from '../NavigationButtons';

import { Link } from 'react-router-dom';

import messages from './Board.messages';

import './Board.css';
import BoardTour from './BoardTour/BoardTour';
import ScrollButtons from '../ScrollButtons';
import { NAVIGATION_BUTTONS_STYLE_SIDES } from '../Settings/Navigation/Navigation.constants';
import ImprovePhraseOutput from './ImprovePhraseOutput';
import SignLanguageViewer from './SignLanguageViewer';
import { isEmpty } from 'lodash';

export class Board extends Component {
  static propTypes = {
    board: PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      tiles: PropTypes.arrayOf(PropTypes.object)
    }),
    /**
     * @ignore
     */
    className: PropTypes.string,
    /**
     *
     */
    disableBackButton: PropTypes.bool,
    /**
     * Callback fired when board tiles are deleted
     */
    onDeleteClick: PropTypes.func,
    /**
     * Callback fired when a board tile is focused
     */
    onFocusTile: PropTypes.func,
    /**
     * Callback fired when a board tile is clicked
     */
    onTileClick: PropTypes.func,
    onSaveBoardClick: PropTypes.func,
    editBoardTitle: PropTypes.func,
    /**
     *
     */
    onLockNotify: PropTypes.func,
    onScannerActive: PropTypes.func,
    /**
     * Callback fired when requesting to load previous board
     */
    onRequestPreviousBoard: PropTypes.func,
    /**
     * Callback fired when requesting to travel and load root board
     */
    onRequestToRootBoard: PropTypes.func,
    /**
     *
     */
    selectedTileIds: PropTypes.arrayOf(PropTypes.string),
    displaySettings: PropTypes.object,
    navigationSettings: PropTypes.object,
    scannerSettings: PropTypes.object,
    userData: PropTypes.object,
    deactivateScanner: PropTypes.func,
    navHistory: PropTypes.arrayOf(PropTypes.string),
    emptyVoiceAlert: PropTypes.bool,
    offlineVoiceAlert: PropTypes.bool,
    onAddRemoveColumn: PropTypes.func,
    onAddRemoveRow: PropTypes.func,
    onLayoutChange: PropTypes.func,
    isRootBoardTourEnabled: PropTypes.bool,
    isUnlockedTourEnabled: PropTypes.bool,
    disableTour: PropTypes.func,
    copiedTiles: PropTypes.arrayOf(PropTypes.object),
    setIsScroll: PropTypes.func,
    isScroll: PropTypes.bool,
    totalRows: PropTypes.number,
    bigTileMode: PropTypes.bool,
    onBigTileModeToggle: PropTypes.func
  };

  static defaultProps = {
    displaySettings: {
      uiSize: 'Standard',
      labelPosition: 'Below',
      shareShowActive: false,
      hideOutputActive: false
    },
    navigationSettings: {},
    scannerSettings: { active: false, delay: 2000, strategy: 'automatic' },
    selectedTileIds: [],
    emptyVoiceAlert: false,
    userData: {}
  };

  constructor(props) {
    super(props);

    this.state = {
      openTitleDialog: false,
      titleDialogValue: props.board && props.board.name ? props.board.name : ''
    };

    this.boardContainerRef = React.createRef();
  }

  componentDidMount() {
    if (this.props.scannerSettings.active) {
      this.props.onScannerActive();
    }
  }

  handleTileClick = tile => {
    const { onTileClick, isSelecting } = this.props;

    if (tile.loadBoard && !isSelecting) {
      this.boardContainerRef.current.scrollTop = 0;
    }
    onTileClick(tile);
  };

  handleTileFocus = tileId => {
    const { onFocusTile, board } = this.props;
    onFocusTile(tileId, board.id);
  };

  handleBoardKeyUp = event => {
    const { onRequestPreviousBoard } = this.props;

    if (event.keyCode === keycode('esc')) {
      onRequestPreviousBoard();
    }
  };

  handleBoardTitleClick = () => {
    if (!this.props.userData.email) {
      return false;
    }
    this.setState({
      openTitleDialog: true,
      titleDialogValue: this.props.board.name
    });
  };

  handleBoardTitleChange = event => {
    const { value: titleDialogValue } = event.target;
    this.setState({ titleDialogValue });
  };

  handleBoardTitleSubmit = async () => {
    if (this.state.titleDialogValue.length) {
      try {
        await this.props.editBoardTitle(this.state.titleDialogValue);
      } catch (e) {}
    }
    this.handleBoardTitleClose();
  };

  handleBoardTitleClose = () => {
    this.setState({
      openTitleDialog: false,
      titleDialogValue: this.props.board.name || this.props.board.id || ''
    });
  };

  renderTiles(tiles) {
    const {
      isSelecting,
      isSaving,
      selectedTileIds,
      displaySettings,
      onSignLanguageRequest
    } = this.props;


    return tiles?.map(tile => {
      const isSelected = selectedTileIds.includes(tile.id);
      const variant = Boolean(tile.loadBoard) ? 'folder' : 'button';

      return (
        <div key={tile.id}>
          <Tile
            backgroundColor={tile.backgroundColor}
            borderColor={tile.borderColor}
            variant={variant}
            onClick={() => {
              this.handleTileClick(tile);
            }}
            onFocus={() => {
              this.handleTileFocus(tile.id);
            }}
          >
            <Symbol
              image={tile.image}
              label={tile.label}
              keyPath={tile.keyPath}
              labelpos={displaySettings.labelPosition}
            />

            {!isSelecting && variant === 'button' && (
              <div
                className="SignLanguageQuickAction"
                onClick={(e) => {
                  e.stopPropagation();
                  onSignLanguageRequest(tile.label);
                }}
              >
                <AccessibilityNewIcon style={{ fontSize: 20 }} />
              </div>
            )}

            {isSelecting && !isSaving && (
              <div className="CheckCircle">
                {isSelected && (
                  <CheckCircleIcon className="CheckCircle__icon" />
                )}
              </div>
            )}
          </Tile>
        </div>
      );
    });
  }

  render() {
    const {
      board,
      intl,
      userData,
      disableBackButton,
      isLocked,
      isSaving,
      isSelectAll,
      isSelecting,
      onAddClick,
      onDeleteClick,
      onEditClick,
      onSaveBoardClick,
      onSelectAllToggle,
      onSelectClick,
      onLockClick,
      onLockNotify,
      onRequestPreviousBoard,
      onRequestToRootBoard,
      selectedTileIds,
      navigationSettings,
      deactivateScanner,
      publishBoard,
      emptyVoiceAlert,
      offlineVoiceAlert,
      onLayoutChange,
      isRootBoardTourEnabled,
      isUnlockedTourEnabled,
      disableTour,
      onCopyTiles,
      onPasteTiles,
      setIsScroll,
      isScroll,
      totalRows,
      changeDefaultBoard,
      improvedPhrase,
      speak,
      license,
      onSignLanguageRequest,
      signLanguageLoading,
      signLanguagePoseUrl,
      signLanguageError,
      signLanguageFallback,
      onSignLanguageClose,
      bigTileMode,
      onBigTileModeToggle
    } = this.props;

    const navbarPosition = this.props.navbarPosition || 'below';
    const tiles = this.renderTiles(board?.tiles);
    const defaultCols = DISPLAY_SIZE_GRID_COLS[this.props.displaySettings.uiSize];
    const tilesPerRow = this.props.tilesPerRow;
    const outputBarPosition = this.props.outputBarPosition || '';
    const isVerticalOutput = outputBarPosition === 'left' || outputBarPosition === 'right';
    const toolbarLayout = this.props.toolbarLayout || '';
    const toolbarPosition = this.props.toolbarPosition || '';
    const cols = tilesPerRow && tilesPerRow > 0
      ? { lg: tilesPerRow, md: tilesPerRow, sm: tilesPerRow, xs: tilesPerRow, xxs: tilesPerRow }
      : defaultCols;
    const spacingMap = { tight: 4, normal: 10, wide: 16, 'extra-wide': 24 };
    const gap = this.props.tileSpacing && spacingMap[this.props.tileSpacing]
      ? spacingMap[this.props.tileSpacing]
      : undefined;
    const isLoggedIn = !!userData.email;
    const isNavigationButtonsOnTheSide =
      navigationSettings.navigationButtonsStyle === undefined ||
      navigationSettings.navigationButtonsStyle ===
        NAVIGATION_BUTTONS_STYLE_SIDES;

    const outputBlock = (
      <React.Fragment>
        <Scannable>
          <div
            className={classNames('Board__output', {
              hidden: this.props.displaySettings.hideOutputActive,
              'Board__output--fixed': !!outputBarPosition,
              [`Board__output--${outputBarPosition}`]: !!outputBarPosition
            })}
          >
            <OutputContainer
              onSignLanguageRequest={onSignLanguageRequest}
              signLanguageLoading={signLanguageLoading}
              vertical={isVerticalOutput}
            />
          </div>
        </Scannable>
        {(signLanguageLoading || signLanguagePoseUrl || signLanguageError) && (
          <SignLanguageViewer
            poseBlobUrl={signLanguagePoseUrl}
            loading={signLanguageLoading}
            error={signLanguageError}
            isFallback={signLanguageFallback}
            onClose={onSignLanguageClose}
          />
        )}
      </React.Fragment>
    );

    const navbarBlock = (
      <React.Fragment>
  
        <div className={classNames('Navbar', 'Board__navbar')}
          style={{
            background: "var(--site-primary-bar-color, #3c3c3c)"
          }}
        >
          <div className="Navbar__group Navbar__group--start">
            {
              !isEmpty(license) ?
              <div
                  style={{
                      padding: "1rem",
                      borderRadius: "8px",
                      display: "flex"
                  }}
                  className="width-license"
              >
                  <div className="text-style">{intl.formatMessage(messages.license)}:</div>
                  <div
                    style={{
                      marginLeft: "0.25rem"
                    }}
                  >
                      {license.license}
                  </div>
              </div>
              :
              null
            }
          </div>
        </div>
      </React.Fragment>
    );

    return (
      <Scanner
        active={this.props.scannerSettings.active}
        iterationInterval={this.props.scannerSettings.delay}
        strategy={this.props.scannerSettings.strategy}
        onDeactivation={deactivateScanner}
      >
        <div
          className={classNames('Board', {
            'is-locked': this.props.isLocked,
            [`Board--output-${outputBarPosition}`]: !!outputBarPosition,
            [`Board--toolbar-${toolbarPosition}`]: !!toolbarPosition,
            'Board--toolbar-single': !!toolbarPosition && toolbarLayout !== ''
          })}
        >
          <BoardTour
            isLocked={isLocked}
            isRootBoardTourEnabled={isRootBoardTourEnabled}
            isUnlockedTourEnabled={isUnlockedTourEnabled}
            disableTour={disableTour}
            intl={intl}
            onDefaultBoardOptionClick={changeDefaultBoard}
          />
          {outputBlock}
          {emptyVoiceAlert && (
            <Alert variant="filled" severity="error">
              {intl.formatMessage(messages.emptyVoiceAlert)}
            </Alert>
          )}
          {offlineVoiceAlert && (
            <Alert
              variant="filled"
              severity="warning"
              action={
                <Button
                  size="small"
                  variant="outlined"
                  style={{ color: 'white', borderColor: 'white' }}
                  component={Link}
                  to="/settings/speech"
                >
                  {intl.formatMessage(messages.offlineChangeVoice)}
                </Button>
              }
            >
              {intl.formatMessage(messages.offlineVoiceAlert)}
            </Alert>
          )}

          <div
            className={classNames('Board__toolbar-container', {
              'Board__toolbar-container--fixed': !!toolbarPosition,
              [`Board__toolbar-container--${toolbarPosition}`]: !!toolbarPosition
            })}
          >
            {toolbarLayout === '' && navbarBlock}
            <EditToolbar
              board={board}
              onBoardTitleClick={this.handleBoardTitleClick}
              className="Board__edit-toolbar"
              isSelectAll={isSelectAll}
              isSelecting={isSelecting}
              isSaving={isSaving}
              isLoggedIn={isLoggedIn}
              onAddClick={onAddClick}
              onDeleteClick={onDeleteClick}
              onEditClick={onEditClick}
              onSaveBoardClick={onSaveBoardClick}
              onSelectAllToggle={onSelectAllToggle}
              onSelectClick={onSelectClick}
              selectedItemsCount={selectedTileIds.length}
              onCopyTiles={onCopyTiles}
              onPasteTiles={onPasteTiles}
              copiedTiles={this.props.copiedTiles}
              communicatorBoards={this.props.communicatorBoards}
              currentCommunicator={this.props.currentCommunicator}
              openCommunicatorDialog={this.props.openCommunicatorDialog}
              switchBoard={this.props.switchBoard}
              editCommunicatorTitle={this.props.editCommunicatorTitle}
              history={this.props.history}
              disableBackButton={disableBackButton}
              onBackClick={onRequestPreviousBoard}
              logoUrl={this.props.logoUrl}
              appName={this.props.appName}
              license={license}
              toolbarLayout={toolbarLayout}
              bigTileMode={bigTileMode}
              onBigTileModeToggle={onBigTileModeToggle}
            />
          </div>
          <div className="BoardSideButtonsContainer">
            {navigationSettings.caBackButtonActive && (
              <NavigationButtons
                active={
                  navigationSettings.caBackButtonActive &&
                  !isSelecting &&
                  (!isSaving || isNavigationButtonsOnTheSide) &&
                  !this.props.scannerSettings.active
                }
                navHistory={this.props.navHistory}
                previousBoard={onRequestPreviousBoard}
                toRootBoard={onRequestToRootBoard}
                isSaving={isSaving}
                isNavigationButtonsOnTheSide={isNavigationButtonsOnTheSide}
              />
            )}
            <Scannable>
              <div
                id="BoardTilesContainer"
                className={classNames('Board__tiles', {
                  ScrollButtonsOnTheSides:
                    navigationSettings.bigScrollButtonsActive &&
                    isNavigationButtonsOnTheSide
                })}
                onKeyUp={this.handleBoardKeyUp}
                ref={this.boardContainerRef}
              >
                {tiles?.length ? (
                    <Grid
                      board={board}
                      edit={isSelecting && !isSaving}
                      cols={cols}
                      gap={gap}
                      onLayoutChange={onLayoutChange}
                      onDragStart={this.props.onGridDragStart}
                      onDragStop={this.props.onGridDragStop}
                      setIsScroll={setIsScroll}
                      isBigScrollBtns={
                        navigationSettings.bigScrollButtonsActive
                      }
                      bigTileMode={bigTileMode}
                    >
                      {tiles}
                    </Grid>
                  ) : (
                    <EmptyBoard />
                  )}
              </div>
            </Scannable>

            {navigationSettings.bigScrollButtonsActive && (
              <ScrollButtons
                active={
                  navigationSettings.bigScrollButtonsActive &&
                  (!isSaving || isNavigationButtonsOnTheSide) &&
                  !this.props.scannerSettings.active &&
                  (isScroll || isNavigationButtonsOnTheSide)
                }
                isScroll={isScroll}
                isSaving={isSaving}
                boardContainer={this.boardContainerRef}
                totalRows={totalRows}
                boardId={board.id}
                isNavigationButtonsOnTheSide={isNavigationButtonsOnTheSide}
              />
            )}
          </div>
          {navigationSettings.improvePhraseActive && (
            <ImprovePhraseOutput
              improvedPhrase={improvedPhrase}
              speak={speak}
            />
          )}
          <Dialog
            open={this.state.openTitleDialog}
            aria-labelledby="board-dialog-title"
            onSubmit={this.handleBoardTitleSubmit}
            onClose={this.handleBoardTitleClose}
          >
            <DialogTitle id="board-dialog-title">
              {intl.formatMessage(messages.editTitle)}
            </DialogTitle>
            <DialogContent>
              <TextField
                autoFocus
                margin="dense"
                id="board title"
                label={intl.formatMessage(messages.boardTitle)}
                type="text"
                fullWidth
                value={this.state.titleDialogValue}
                onChange={this.handleBoardTitleChange}
              />
            </DialogContent>
            <DialogActions>
              <Button onClick={this.handleBoardTitleClose} color="primary">
                {intl.formatMessage(messages.boardEditTitleCancel)}
              </Button>
              <Button
                onClick={this.handleBoardTitleSubmit}
                color="primary"
                variant="contained"
              >
                {intl.formatMessage(messages.boardEditTitleAccept)}
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      </Scanner>
    );
  }
}

export default Board;
